import type { VectorSourceDescriptor } from '../data/model';
import { geometryFamiliesForSource } from '../styles/geometry';
import { chooseInitialLabelField } from './fields';
import type { LayerLabelConfiguration } from './model';

export const DEFAULT_LABEL_TEXT_SIZE = 13;
export const DEFAULT_LABEL_FONT_FAMILY = 'inter' as const;
export const DEFAULT_LABEL_FONT_WEIGHT = 'regular' as const;
export const DEFAULT_LABEL_FONT_STYLE = 'normal' as const;
export const DEFAULT_LABEL_TEXT_COLOUR = '#263238';
export const DEFAULT_LABEL_HALO_COLOUR = '#ffffff';
export const DEFAULT_LABEL_HALO_WIDTH = 1.5;
export const DEFAULT_POINT_LABEL_OFFSET = 3;
export const DEFAULT_LINE_LABEL_OFFSET = 0;
export const DEFAULT_LABEL_COLLISION_SPACING = 2;

export function createDefaultLayerLabelConfiguration(): LayerLabelConfiguration {
  return {
    enabled: false,
    field: null,
    filter: null,
    fontFamily: DEFAULT_LABEL_FONT_FAMILY,
    fontWeight: DEFAULT_LABEL_FONT_WEIGHT,
    fontStyle: DEFAULT_LABEL_FONT_STYLE,
    textSize: DEFAULT_LABEL_TEXT_SIZE,
    textColour: DEFAULT_LABEL_TEXT_COLOUR,
    haloColour: DEFAULT_LABEL_HALO_COLOUR,
    haloWidth: DEFAULT_LABEL_HALO_WIDTH,
    pointPlacement: 'auto',
    pointOffset: DEFAULT_POINT_LABEL_OFFSET,
    lineOffset: DEFAULT_LINE_LABEL_OFFSET,
    collisionSpacing: DEFAULT_LABEL_COLLISION_SPACING,
  };
}

export type InitialLabelContrast = 'light' | 'dark';

/** New-import recipe only. Saved settings and historical fieldless defaults are never restyled. */
export function createInitialLayerLabelConfiguration(
  source: VectorSourceDescriptor,
  contrast: InitialLabelContrast = 'light',
): LayerLabelConfiguration {
  const families = geometryFamiliesForSource(source);
  const geometry = families.length === 1 ? families[0] : null;
  return {
    ...createDefaultLayerLabelConfiguration(),
    field: chooseInitialLabelField(source.fields, source.data),
    fontWeight: geometry === 'point' || geometry === 'polygon' ? 'bold' : 'regular',
    textSize: geometry === 'polygon' ? 14 : 13,
    textColour: contrast === 'dark' ? '#e4e8ec' : '#25313b',
    haloColour: contrast === 'dark' ? '#24282d' : DEFAULT_LABEL_HALO_COLOUR,
    haloWidth: 1,
    pointOffset: 4,
    lineOffset: 8,
    collisionSpacing: 3,
  };
}
